import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 25px 20px;
  gap: 25px;
  border-radius: 14px;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.secondary.background};
`;

export const Price = styled(Typography.Title).attrs({ $variant: '4' })`
  font-size: 26px;
`;

export const ContactsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
